// extracted by mini-css-extract-plugin
export default {"labelContainer":"lgvt4I"};